<template>
  <el-menu-item :index="routeChildren.code" @click="handleLink(routeChildren.path)">
    <!-- <vab-icon
      v-if="routeChildren.meta.icon"
      :icon="['fas', routeChildren.meta.icon]"
      class="vab-fas-icon"
    /> -->
    <span>{{ routeChildren.name }}</span>
    <!-- <el-tag
      v-if="routeChildren.meta && routeChildren.meta.badge"
      effect="dark"
      type="danger"
    >
      {{ routeChildren.meta.badge }}
    </el-tag> -->
  </el-menu-item>
</template>

<script>
  // import path from 'path'

  export default {
    name: 'VabMenuItem',
    props: {
      routeChildren: {
        type: Object,
        default() {
          return null
        },
      },
      item: {
        type: Object,
        default() {
          return null
        },
      },
      fullPath: {
        type: String,
        default: '',
      },
    },
  methods: {
    isExternal(path) {
      return /^(https?:|mailto:|tel:)/.test(path)
    },
      handlePath(routePath) {
        if (this.isExternal(routePath)) {
          return routePath
        }
        if (this.isExternal(this.fullPath)) {
          return this.fullPath
        }
        return path.resolve(this.fullPath, routePath)
      },
    handleLink(path) {
      // this.$router.push(path)
        // const routePath = this.routeChildren.code

        //   if (this.isExternal(routePath)) {
        //     window.open(routePath)
        //   } else if (this.isExternal(this.fullPath)) {
        //     window.open(this.fullPath)
        //   } else  {
           
        //   }
        
      },
    },
  }
</script>
